import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { ICrisisModel, IThunkEditManualCrisisAllocationAddress } from '../types';

const onEditManualCrisisAllocationAddress: IThunkEditManualCrisisAllocationAddress = thunk(
  async (actions: Actions<ICrisisModel>, { clinicId, followUpAllocationId, data }) => {
    const updated = await api.crisis
      .editManualCrisisAllocationAddress(clinicId, followUpAllocationId, data)
      .then(r => r.data);

    await actions.onGetCrisisCalls({ clinicId });
    await actions.onGetCrisisCallTeamMembers({ clinicId });

    return updated;
  },
);

export default onEditManualCrisisAllocationAddress;
